
import Navbar from '../visa-travel-tips/components/Navbar';
import Footer from '../visa-travel-tips/components/Footer';

export default function OutletShoppingGuide() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-pink-600 to-purple-600 text-white py-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Kinh nghiệm mua sắm tại Outlet Mall Mỹ
            </h1>
            <p className="text-xl text-pink-100 mb-8 max-w-3xl mx-auto">
              Hướng dẫn chi tiết săn hàng hiệu giảm giá 30-70% tại các outlet nổi tiếng
            </p>
          </div>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <a href="/" className="hover:text-teal-600 transition-colors">Trang chủ</a>
            <span>/</span>
            <a href="/visa-travel-tips" className="hover:text-teal-600 transition-colors">Kinh nghiệm du lịch</a>
            <span>/</span>
            <span className="text-gray-900 font-medium">Outlet shopping</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <article className="prose prose-lg max-w-none">
          {/* Introduction */}
          <div className="bg-gradient-to-r from-pink-50 to-purple-50 rounded-xl p-8 mb-12">
            <p className="text-lg leading-relaxed text-gray-700 mb-0">
              Outlet shopping là một trong những trải nghiệm không thể bỏ lỡ khi du lịch Mỹ. 
              Với hàng trăm thương hiệu designer và lifestyle brands giảm giá 30-70%, 
              đây là cơ hội tuyệt vời để mua sắm các sản phẩm chất lượng cao với giá cả phải chăng.
            </p>
          </div>

          {/* Top Outlet Centers */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">🛍️ Top Outlet Centers Must-Visit</h2>

            {/* Woodbury Common Premium Outlets */}
            <div className="bg-white border border-gray-200 rounded-xl p-8 mb-8 shadow-sm">
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 bg-pink-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-pink-600 text-2xl"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    Woodbury Common Premium Outlets (New York)
                  </h3>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <p className="text-gray-700">
                        Outlet lớn nhất và nổi tiếng nhất nước Mỹ, cách NYC 1 giờ lái xe. 
                        Hơn 250 stores với luxury brands như Prada, Gucci, Coach, Kate Spade.
                      </p>
                      <div className="bg-pink-50 rounded-lg p-4">
                        <h4 className="font-semibold text-pink-900 mb-2">🏷️ Luxury brands:</h4>
                        <ul className="text-sm space-y-1 grid grid-cols-2 gap-1">
                          <li>• Prada (40-60% off)</li>
                          <li>• Gucci (30-50% off)</li>
                          <li>• Coach (50-70% off)</li>
                          <li>• Kate Spade (60-80% off)</li>
                          <li>• Burberry (40-60% off)</li>
                          <li>• Tory Burch (50-70% off)</li>
                        </ul>
                      </div>
                    </div>
                    <div className="space-y-4">
                      <div className="bg-blue-50 rounded-lg p-4">
                        <h4 className="font-semibold text-blue-900 mb-2">🚌 Cách đến:</h4>
                        <ul className="text-sm space-y-1">
                          <li>• <strong>Bus tours:</strong> $45-65 from NYC (Gray Line, Short Line)</li>
                          <li>• <strong>Rent car:</strong> 1 hour drive from Manhattan</li>
                          <li>• <strong>VIP Shopper Club:</strong> $5 membership, extra discounts</li>
                          <li>• <strong>Best days:</strong> Weekdays ít đông hơn</li>
                        </ul>
                      </div>
                      <div className="bg-green-50 rounded-lg p-4">
                        <h4 className="font-semibold text-green-900 mb-2">💰 Money-saving tips:</h4>
                        <ul className="text-sm space-y-1">
                          <li>• Download app để nhận exclusive deals</li>
                          <li>• Sign up email để 10% off coupon</li>
                          <li>• Tax-free shopping cho tourists</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Desert Hills Premium Outlets */}
            <div className="bg-white border border-gray-200 rounded-xl p-8 mb-8 shadow-sm">
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-sun-line text-orange-600 text-2xl"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    Desert Hills Premium Outlets (California)
                  </h3>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <p className="text-gray-700">
                        Nằm giữa LA và Las Vegas, outlet này perfect cho road trip California. 
                        180+ stores với California weather year-round và outdoor shopping experience tuyệt vời.
                      </p>
                      <div className="bg-orange-50 rounded-lg p-4">
                        <h4 className="font-semibold text-orange-900 mb-2">🌟 Highlights:</h4>
                        <ul className="text-sm space-y-1">
                          <li>• Bottega Veneta (designer leather goods)</li>
                          <li>• Saint Laurent (luxury fashion)</li>
                          <li>• Jimmy Choo (designer shoes)</li>
                          <li>• Armani (Italian fashion)</li>
                          <li>• Tom Ford (luxury accessories)</li>
                        </ul>
                      </div>
                    </div>
                    <div>
                      <div className="bg-yellow-50 rounded-lg p-4">
                        <h4 className="font-semibold text-yellow-900 mb-2">📍 Location benefits:</h4>
                        <ul className="text-sm space-y-1">
                          <li>• 2 giờ từ LA, 1.5 giờ từ Las Vegas</li>
                          <li>• Perfect weather year-round</li>
                          <li>• Beautiful desert mountain views</li>
                          <li>• Less crowded than NYC outlets</li>
                          <li>• Free parking</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Jersey Gardens */}
            <div className="bg-white border border-gray-200 rounded-xl p-8 mb-8 shadow-sm">
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-store-3-line text-green-600 text-2xl"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    Jersey Gardens (New Jersey)
                  </h3>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <p className="text-gray-700">
                        Outlet mall lớn nhất New Jersey, chỉ 20 phút từ NYC với shuttle service. 
                        Indoor shopping với climate control, perfect cho mọi thời tiết.
                      </p>
                      <div className="bg-green-50 rounded-lg p-4">
                        <h4 className="font-semibold text-green-900 mb-2">🛒 Popular stores:</h4>
                        <ul className="text-sm space-y-1">
                          <li>• Nike Factory Store</li>
                          <li>• Adidas Outlet</li>
                          <li>• Under Armour</li>
                          <li>• Forever 21</li>
                          <li>• H&M</li>
                          <li>• Levi's Outlet Store</li>
                        </ul>
                      </div>
                    </div>
                    <div>
                      <div className="bg-blue-50 rounded-lg p-4">
                        <h4 className="font-semibold text-blue-900 mb-2">🎯 Best for:</h4>
                        <ul className="text-sm space-y-1">
                          <li>• Casual/sportswear shopping</li>
                          <li>• Family-friendly prices</li>
                          <li>• Bad weather days (indoor)</li>
                          <li>• Quick trips from NYC</li>
                          <li>• Food court + dining</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Orlando Premium Outlets */}
            <div className="bg-white border border-gray-200 rounded-xl p-8 mb-8 shadow-sm">
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-mickey-line text-blue-600 text-2xl"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    Orlando Premium Outlets (Florida)
                  </h3>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <p className="text-gray-700">
                        Perfect combination với Disney World vacation. 2 locations: International Drive (tourist area) và Vineland Avenue (luxury focus).
                      </p>
                      <div className="bg-blue-50 rounded-lg p-4">
                        <h4 className="font-semibold text-blue-900 mb-2">🏰 Tourist-friendly:</h4>
                        <ul className="text-sm space-y-1">
                          <li>• Free shuttle từ hotels</li>
                          <li>• International customer service</li>
                          <li>• Tax refund services</li>
                          <li>• Currency exchange</li>
                          <li>• Multilingual staff</li>
                        </ul>
                      </div>
                    </div>
                    <div>
                      <div className="bg-purple-50 rounded-lg p-4">
                        <h4 className="font-semibold text-purple-900 mb-2">💎 Vineland location:</h4>
                        <ul className="text-sm space-y-1">
                          <li>• Luxury brands focus</li>
                          <li>• Less touristy, better deals</li>
                          <li>• Easier parking</li>
                          <li>• Premium shopping experience</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Shopping Strategy */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">📋 Chiến lược shopping hiệu quả</h2>

            <div className="grid md:grid-cols-2 gap-8 mb-8">
              <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-xl p-8">
                <h3 className="text-xl font-bold text-green-900 mb-6">📅 Chuẩn bị trước khi đi</h3>
                <div className="space-y-4">
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-green-800 mb-2">📱 Research & Apps</h4>
                    <ul className="text-sm space-y-1">
                      <li>• Download outlet apps cho exclusive coupons</li>
                      <li>• Check store directories trước</li>
                      <li>• Follow brands trên social media</li>
                      <li>• Sign up newsletters để VIP offers</li>
                    </ul>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-green-800 mb-2">🎯 Make a list</h4>
                    <ul className="text-sm space-y-1">
                      <li>• Prioritize must-have items</li>
                      <li>• Know your sizes (US sizing khác VN)</li>
                      <li>• Set budget cho mỗi category</li>
                      <li>• Research regular prices để biết deal tốt</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-8">
                <h3 className="text-xl font-bold text-purple-900 mb-6">🛍️ Ngày shopping</h3>
                <div className="space-y-4">
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-purple-800 mb-2">⏰ Timing strategy</h4>
                    <ul className="text-sm space-y-1">
                      <li>• Arrive khi mở cửa (ít đông)</li>
                      <li>• Weekdays tốt hơn weekends</li>
                      <li>• Mang comfortable shoes</li>
                      <li>• Plan 6-8 giờ cho major outlets</li>
                    </ul>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-purple-800 mb-2">🎒 What to bring</h4>
                    <ul className="text-sm space-y-1">
                      <li>• Large bag/suitcase</li>
                      <li>• Portable phone charger</li>
                      <li>• Snacks + water bottle</li>
                      <li>• Credit cards (better exchange rates)</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6">
              <h4 className="font-semibold text-yellow-800 mb-3">🏷️ Coupon & Discount Hacks</h4>
              <div className="grid md:grid-cols-3 gap-4">
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Tourist booklets:</strong> Free tại hotels</li>
                  <li>• <strong>VIP Shopper Club:</strong> $5 fee, exclusive deals</li>
                  <li>• <strong>Social media:</strong> Flash sales announcements</li>
                </ul>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Email sign-up:</strong> 10% welcome coupon</li>
                  <li>• <strong>Birthday offers:</strong> Special discounts</li>
                  <li>• <strong>Student discounts:</strong> Mang student ID</li>
                </ul>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Stack deals:</strong> Store sale + coupon</li>
                  <li>• <strong>Price matching:</strong> Một số stores accept</li>
                  <li>• <strong>Tax-free:</strong> Tourist tax refund</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Brand Categories & Pricing */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">💰 Bảng giá brands phổ biến</h2>

            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-white border border-gray-200 rounded-xl p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4 text-center">👜 Luxury & Designer</h3>
                <div className="space-y-3">
                  <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                    <div>
                      <span className="font-medium">Coach handbags</span>
                      <div className="text-xs text-gray-600">Regular: $200-800</div>
                    </div>
                    <div className="text-right">
                      <span className="font-bold text-green-600">$80-350</span>
                      <div className="text-xs text-green-600">50-70% off</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                    <div>
                      <span className="font-medium">Kate Spade bags</span>
                      <div className="text-xs text-gray-600">Regular: $150-500</div>
                    </div>
                    <div className="text-right">
                      <span className="font-bold text-green-600">$60-200</span>
                      <div className="text-xs text-green-600">60-80% off</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                    <div>
                      <span className="font-medium">Michael Kors</span>
                      <div className="text-xs text-gray-600">Regular: $100-400</div>
                    </div>
                    <div className="text-right">
                      <span className="font-bold text-green-600">$40-150</span>
                      <div className="text-xs text-green-600">50-70% off</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                    <div>
                      <span className="font-medium">Tory Burch</span>
                      <div className="text-xs text-gray-600">Regular: $200-600</div>
                    </div>
                    <div className="text-right">
                      <span className="font-bold text-green-600">$100-300</span>
                      <div className="text-xs text-green-600">40-60% off</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4 text-center">👟 Sportswear & Casual</h3>
                <div className="space-y-3">
                  <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                    <div>
                      <span className="font-medium">Nike sneakers</span>
                      <div className="text-xs text-gray-600">Regular: $80-200</div>
                    </div>
                    <div className="text-right">
                      <span className="font-bold text-blue-600">$40-120</span>
                      <div className="text-xs text-blue-600">30-50% off</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                    <div>
                      <span className="font-medium">Adidas shoes</span>
                      <div className="text-xs text-gray-600">Regular: $60-180</div>
                    </div>
                    <div className="text-right">
                      <span className="font-bold text-blue-600">$35-100</span>
                      <div className="text-xs text-blue-600">40-60% off</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                    <div>
                      <span className="font-medium">Levi's jeans</span>
                      <div className="text-xs text-gray-600">Regular: $50-120</div>
                    </div>
                    <div className="text-right">
                      <span className="font-bold text-blue-600">$25-60</span>
                      <div className="text-xs text-blue-600">40-50% off</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                    <div>
                      <span className="font-medium">Under Armour</span>
                      <div className="text-xs text-gray-600">Regular: $30-100</div>
                    </div>
                    <div className="text-right">
                      <span className="font-bold text-blue-600">$15-60</span>
                      <div className="text-xs text-blue-600">40-60% off</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-6 bg-purple-50 rounded-lg p-6">
              <h4 className="font-semibold text-purple-900 mb-4 text-center">🛍️ Best Value Categories</h4>
              <div className="grid md:grid-cols-4 gap-4">
                <div className="text-center">
                  <div className="text-2xl mb-2">👜</div>
                  <h5 className="font-medium">Handbags</h5>
                  <p className="text-sm text-gray-600">Coach, Kate Spade, MK</p>
                </div>
                <div className="text-center">
                  <div className="text-2xl mb-2">👟</div>
                  <h5 className="font-medium">Sneakers</h5>
                  <p className="text-sm text-gray-600">Nike, Adidas, Converse</p>
                </div>
                <div className="text-center">
                  <div className="text-2xl mb-2">👕</div>
                  <h5 className="font-medium">Clothing</h5>
                  <p className="text-sm text-gray-600">Ralph Lauren, Tommy</p>
                </div>
                <div className="text-center">
                  <div className="text-2xl mb-2">🕶️</div>
                  <h5 className="font-medium">Accessories</h5>
                  <p className="text-sm text-gray-600">Ray-Ban, Fossil</p>
                </div>
              </div>
            </div>
          </section>

          {/* Seasonal Shopping */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">📅 Lịch mua sắm theo mùa</h2>

            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-8 mb-8">
              <h3 className="text-xl font-bold text-blue-900 mb-6 text-center">🎯 Sale seasons tốt nhất</h3>
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <h4 className="font-semibold text-blue-800 mb-4">🔥 Major sale periods:</h4>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <span className="w-3 h-3 bg-red-500 rounded-full mt-2"></span>
                      <div>
                        <strong>Black Friday (Nov 29):</strong> Biggest discounts của năm, 50-80% off
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-3 h-3 bg-blue-500 rounded-full mt-2"></span>
                      <div>
                        <strong>Cyber Monday:</strong> Online deals, perfect cho pre-trip shopping
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-3 h-3 bg-green-500 rounded-full mt-2"></span>
                      <div>
                        <strong>After Christmas (Dec 26-31):</strong> Winter clearance sales
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-3 h-3 bg-yellow-500 rounded-full mt-2"></span>
                      <div>
                        <strong>Back-to-School (Aug):</strong> Casual wear, backpacks, electronics
                      </div>
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold text-blue-800 mb-4">📆 Monthly highlights:</h4>
                  <ul className="space-y-2 text-sm">
                    <li><strong>January:</strong> Winter clothing clearance</li>
                    <li><strong>February:</strong> Valentine's jewelry deals</li>
                    <li><strong>March:</strong> Spring clothing arrivals</li>
                    <li><strong>April-May:</strong> Spring cleaning sales</li>
                    <li><strong>June:</strong> Summer wear, swimwear</li>
                    <li><strong>July:</strong> Mid-summer clearance</li>
                    <li><strong>August:</strong> Back-to-school specials</li>
                    <li><strong>September:</strong> Fall fashion launches</li>
                    <li><strong>October:</strong> Fall clearance begins</li>
                    <li><strong>November:</strong> Black Friday madness</li>
                    <li><strong>December:</strong> Holiday gifts, winter gear</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Tax & Customs */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">📋 Tax & Customs cho tourists</h2>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-green-50 rounded-lg p-6">
                <h4 className="font-semibold text-green-900 mb-4 flex items-center gap-2">
                  <i className="ri-percent-line"></i>
                  Sales Tax tại outlets
                </h4>
                <div className="space-y-3">
                  <div className="bg-white rounded-lg p-3">
                    <div className="flex justify-between mb-1">
                      <span className="font-medium">New York</span>
                      <span className="font-bold">8.25%</span>
                    </div>
                    <p className="text-xs text-gray-600">Woodbury Common có tourist tax refund</p>
                  </div>
                  <div className="bg-white rounded-lg p-3">
                    <div className="flex justify-between mb-1">
                      <span className="font-medium">California</span>
                      <span className="font-bold">7.25-10%</span>
                    </div>
                    <p className="text-xs text-gray-600">Tùy county, Desert Hills ~8%</p>
                  </div>
                  <div className="bg-white rounded-lg p-3">
                    <div className="flex justify-between mb-1">
                      <span className="font-medium">Florida</span>
                      <span className="font-bold">6-8.5%</span>
                    </div>
                    <p className="text-xs text-gray-600">Orlando outlets có tourist services</p>
                  </div>
                  <div className="bg-white rounded-lg p-3">
                    <div className="flex justify-between mb-1">
                      <span className="font-medium">Delaware</span>
                      <span className="font-bold text-green-600">0%</span>
                    </div>
                    <p className="text-xs text-gray-600">No sales tax state!</p>
                  </div>
                </div>
              </div>

              <div className="bg-orange-50 rounded-lg p-6">
                <h4 className="font-semibold text-orange-900 mb-4 flex items-center gap-2">
                  <i className="ri-plane-line"></i>
                  Customs về VN
                </h4>
                <div className="space-y-4">
                  <div className="bg-white rounded-lg p-4">
                    <h5 className="font-medium mb-2">🎁 Hạn mức miễn thuế:</h5>
                    <ul className="text-sm space-y-1">
                      <li>• <strong>$600 USD</strong> cho hành khách từ 18 tuổi</li>
                      <li>• <strong>$300 USD</strong> cho trẻ em dưới 18</li>
                      <li>• Tính theo giá trị mua (không tính tax)</li>
                    </ul>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h5 className="font-medium mb-2">📄 Cần lưu receipt:</h5>
                    <ul className="text-sm space-y-1">
                      <li>• Mang tất cả receipts gốc</li>
                      <li>• Chụp ảnh backup</li>
                      <li>• Declare trung thực tại customs</li>
                      <li>• Thuế 10% nếu vượt hạn mức</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-6 bg-red-50 border border-red-200 rounded-lg p-6">
              <h4 className="font-semibold text-red-800 mb-3">⚠️ Lưu ý quan trọng</h4>
              <div className="grid md:grid-cols-2 gap-4">
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Hạn chế:</strong> Không được mang thực phẩm, thực vật</li>
                  <li>• <strong>Electronics:</strong> Tối đa 2 điện thoại, 1 laptop</li>
                  <li>• <strong>Alcohol:</strong> 1.5L rượu/người (trên 18 tuổi)</li>
                </ul>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Thuốc lá:</strong> 400 điếu/người</li>
                  <li>• <strong>Cosmetics:</strong> Không giới hạn số lượng</li>
                  <li>• <strong>Jewelry:</strong> Cần declare nếu giá trị cao</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Packing & Logistics */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">🧳 Logistics & Packing</h2>

            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-blue-50 rounded-lg p-6">
                <h4 className="font-semibold text-blue-900 mb-4 flex items-center gap-2">
                  <i className="ri-suitcase-line"></i>
                  Chuẩn bị hành lý
                </h4>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Empty suitcase:</strong> Hoặc mua thêm tại outlet</li>
                  <li>• <strong>Packing cubes:</strong> Organize mua sắm</li>
                  <li>• <strong>Duffel bag:</strong> Foldable, lightweight</li>
                  <li>• <strong>Bubble wrap:</strong> Protect fragile items</li>
                  <li>• <strong>Scale:</strong> Check weight trước flight</li>
                </ul>
              </div>

              <div className="bg-purple-50 rounded-lg p-6">
                <h4 className="font-semibold text-purple-900 mb-4 flex items-center gap-2">
                  <i className="ri-truck-line"></i>
                  Shipping options
                </h4>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>USPS:</strong> $50-150 cho 20-30lbs box</li>
                  <li>• <strong>FedEx/UPS:</strong> Nhanh hơn, đắt hơn</li>
                  <li>• <strong>Pack & Ship stores:</strong> Tại outlets</li>
                  <li>• <strong>Insurance:</strong> Cho valuable items</li>
                  <li>• <strong>Delivery time:</strong> 7-14 ngày</li>
                </ul>
              </div>

              <div className="bg-green-50 rounded-lg p-6">
                <h4 className="font-semibold text-green-900 mb-4 flex items-center gap-2">
                  <i className="ri-money-dollar-circle-line"></i>
                  Payment methods
                </h4>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Credit cards:</strong> Best exchange rates</li>
                  <li>• <strong>No foreign fees:</strong> Chase Sapphire, Capital One</li>
                  <li>• <strong>Cash:</strong> Một số stores discount</li>
                  <li>• <strong>Mobile payment:</strong> Apple Pay, Google Pay</li>
                  <li>• <strong>Gift cards:</strong> Buy với promotion</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Success tips */}
          <section className="mb-12">
            <div className="bg-gradient-to-r from-pink-500 to-purple-600 rounded-xl p-8 text-white">
              <h2 className="text-2xl font-bold mb-6 text-center">🏆 Pro Tips cho outlet shopping</h2>
              <div className="grid md:grid-cols-3 gap-6">
                <div>
                  <h3 className="font-semibold mb-4 text-pink-100">Trước khi mua:</h3>
                  <ul className="space-y-2 text-sm text-pink-100">
                    <li>• Try trước khi mua (sizes khác VN)</li>
                    <li>• Check quality carefully</li>
                    <li>• Compare với retail prices</li>
                    <li>• Ask về return policy</li>
                    <li>• Look for additional discounts</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-semibold mb-4 text-pink-100">Shopping hacks:</h3>
                  <ul className="space-y-2 text-sm text-pink-100">
                    <li>• Follow stores trên social media</li>
                    <li>• Ask staff về upcoming sales</li>
                    <li>• Check clearance sections first</li>
                    <li>• Bundle discounts với multiple items</li>
                    <li>• Price match nếu possible</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-semibold mb-4 text-pink-100">Avoid mistakes:</h3>
                  <ul className="space-y-2 text-sm text-pink-100">
                    <li>• Don't impulse buy vì "deals"</li>
                    <li>• Check return policy carefully</li>
                    <li>• Verify authentic merchandise</li>
                    <li>• Keep all receipts organized</li>
                    <li>• Stay hydrated & take breaks</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* CTA */}
          <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-xl p-8 text-white text-center">
            <h3 className="text-2xl font-bold mb-4">Sẵn sàng shopping spree tại Mỹ?</h3>
            <p className="mb-6 text-orange-100">
              Chúng tôi sẽ giúp bạn lập kế hoạch shopping hiệu quả nhất!
            </p>
            <div className="flex flex-col gap-3 max-w-md mx-auto">
              <button className="bg-white text-orange-600 px-8 py-3 rounded-lg text-lg font-semibold hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer">
                Tư vấn lịch trình shopping
              </button>
              <button className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-3 rounded-lg text-lg font-semibold border-2 border-white transition-colors whitespace-nowrap cursor-pointer">
                Tải shopping checklist
              </button>
            </div>
          </div>
        </article>
      </div>

      <Footer />
    </div>
  );
}
